import React from 'react';
import { Button } from '@/components/ui/button';
import { Link } from 'react-router-dom';
import { useEffect } from 'react'

function Verhaal() {

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className='my-36 px-8'>

      {/* Intro */}
      <section className='items-center'>
        <div className='font-gotham text-black text-medium mx-auto max-w-prose my-12'>
          <h1 className="my-6">
            Ik ben Jo
          </h1>
          <p className="text-base font-gotham">
            Ik ben Jo! laat zien hoe kunst nieuwe betekenis krijgt in het leven van Amsterdammers vandaag. Het project viert de nalatenschap van Jo van Gogh-Bonger als symbool van doorzettingsvermogen, creativiteit en solidariteit en bouwt verder aan een gemeenschap waarin meer dan 100 vrouwen elkaar inspireren om hun verhaal te delen.
          </p>
        </div>
      </section>

      <div className=" items-center mx-auto w-1 h-40 my-12 bg-black rounded-full"></div>

      {/* Section 2: Over Jo */}
      <section className='items-center'>
      <div className="mb-2 mx-auto max-w-4xl rounded-2xl overflow-hidden">
          <div className="relative w-full h-0 pb-[56.25%]">
            <iframe
              className="absolute top-0 left-0 w-full h-full rounded-2xl"
              src="https://www.youtube.com/embed/x_iLSlZR4Ng?start=76"
              title="YouTube video player"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              referrerPolicy="strict-origin-when-cross-origin"
              allowFullScreen
            ></iframe>
            
            </div>
          <p className='font-gotham text-xs p-2 px-6'>video: Narjes Mohamadi & Rose Stories</p>
        </div>
        <div className='font-gotham text-black text-medium mx-auto max-w-prose my-12'>
          <h1 className="my-6">
            Geïnspireerd door Jo
          </h1>
          <p className="text-base font-gotham">
          Johanna (Jo) van Gogh-Bonger (1862–1925) was de schoonzus van Vincent van Gogh, en het was mede dankzij haar dat zijn werk wereldberoemd werd. Jo groeide op in een huishouden vol muziek en literatuur en hield vanaf jonge leeftijd een dagboek bij, waarin ze haar gevoelens, idealen en ambities onderzocht in haar levenslange zoektocht naar zelfkennis. In 1889 trouwde ze met Theo, de broer van Vincent. Hun korte maar gelukkige huwelijk werd overschaduwd door tragedie: eerst Vincents dood in 1890, gevolgd door Theo’s vroegtijdige overlijden enkele maanden later.
<br></br><br></br>
<div className='grid max-w-prose grid-cols-2 gap-6 my-4'>
  <div>
        <img
          src={"/assets/images/vangoghmuseum-s0283V1963-800.jpg"}
          alt={`${"hello"} Hover`}
          className="w-[100%] h-auto mx-auto object-cover rounded-3xl aspect-square "
        />
{/*         <p className='px-6 py-2 text-xs'>Portret van Jo van Gogh-Bonger schrijvende, Johan Cohen Gosschalk 1902 Van Gogh Museum Collection</p> */}
<p className='font-gotham text-xs p-2 px-6'>Johan Cohen Gosschalk, Portret van Jo van Gogh-Bonger schrijvende, ca. 1902, Van Gogh Museum Amsterdam (Vincent van Gogh Stichting)</p>
        </div>
        <div>
                <img
          src={"/assets/images/18mag-vangogh-promoimage-superJumbo.jpg"}
          alt={`${"hello"} Hover`}
          className="w-[100%] h-auto mx-auto object-cover rounded-3xl aspect-square "
        />
        <p className='font-gotham text-xs p-2 px-6'>Jo Bonger, 1884, Van Gogh Museum Amsterdam (Vincent van Gogh Stichting)</p>
        </div>
        </div>
        <br></br>
        Ter nagedachtenis aan haar man zette Jo zich onvermoeibaar in om het werk van Vincent bekend te maken. Door het uitgeven van zijn brieven, het organiseren van tentoonstellingen en het delen van zijn kunst met de wereld zorgde ze ervoor dat zijn werk de erkenning kreeg die het verdiende. In haar doorzettingsvermogen, ambitie en liefdevolle houding is Jo van Gogh-Bonger een vrouw die tot de verbeelding spreekt en blijft inspireren.</p>
        </div>
      </section>

      <div className=" items-center mx-auto w-1 h-40 my-12 bg-black rounded-full"></div>

      {/* Section 2: Creativiteit en community */}
      <section className="items-center">
      <div className='grid max-w-4xl grid-cols-2 gap-6 items-center mx-auto'>
        <div>
      <img
          src={"/assets/images/download_13.jpg"}
          alt={`${"hello"} Hover`}
          className="w-[100%] h-auto mx-auto object-cover rounded-3xl aspect-square "
        />
        <p className='font-gotham text-xs p-2 px-6'>afbeelding: Van Gogh Museum</p>
        </div>
        <div>
        <img
          src={"/assets/images/download_24.jpg"}
          alt={`${"hello"} Hover`}
          className="w-[100%] h-auto mx-auto object-cover rounded-3xl aspect-square "
        />
          <p className='font-gotham text-xs p-2 px-6'>afbeelding: Van Gogh Museum</p>
          </div>
        </div>

  {/* TEXT — narrow & centered */}
  <div className="font-gotham text-black text-medium mx-auto max-w-prose my-12">
    <h1 className="my-6">
      Creativiteit en community
    </h1>
    <p className="text-base font-gotham">
      Het Van Gogh Museum verkent nieuwe manieren om kunst te verbinden met het leven van Amsterdammers nu. Door de nalatenschap van Jo tot leven te brengen, wil het museum reflectie, dialoog en creativiteit stimuleren en Jo neerzetten als een inspirerend voorbeeld van veerkracht en vastberadenheid.
    </p>
  </div>
</section>

      <div className=" items-center mx-auto w-1 h-40 my-12 bg-black rounded-full"></div>

      {/* Section 3: Van idee tot samenwerking */}
<section className="mx-auto my-12 max-w-5xl px-4">
        <div className="flex flex-col gap-8 items-center md:flex-row md:items-start">
          <div className='flex-1'>
          <img
            src="/assets/images/BMS_0656-Enhanced-NR.jpg"
            alt="hello Hover"
            className="
        w-full
        h-auto object-cover
        rounded-3xl aspect-square
      "
          />
          <p className='font-gotham text-xs p-2 px-6'>afbeelding: Blooming Moon Studio</p>
          </div>
          <div className="font-gotham text-black mx-auto max-w-prose md:mx-0 md:flex-1">
            <h1 className="my-6">Van idee tot samenwerking</h1>
            <p className="text-base font-gotham">
        In samenwerking met de alliantie Samen sterk met werk – die bestaat uit Vrouw en Vaart (Nieuw-West), Buurvrouwennetwerk Gaasperdam (Zuidoost), Stichting Malak (Noord), Stichting Prachtvrouw (Oost) en Stichting Vrouwen Vooruit (West) – komt een reeks creatieve workshops in heel Amsterdam tot stand.
        <br /><br />
        Deze activiteiten nodigen vrouwen uit om Jo’s verhaal te ontdekken, inspiratie te vinden en na te denken over hun eigen levensloop.
      </p>
          </div>
        </div>
      </section>

      <div className=" items-center mx-auto w-1 h-40 my-12 bg-black rounded-full"></div>

      {/* Documentary (keep video block) */}
      <section className='items-center'>
        <div className='font-gotham text-black text-medium mx-auto max-w-prose my-12'>
          <h1 className="my-6">
            Ik ben Jo: Documentaire
          </h1>
        </div>

        <div className="mb-2 mx-auto max-w-4xl rounded-2xl overflow-hidden">
          <div className="relative w-full h-0 pb-[56.25%]">
            <iframe
              className="absolute top-0 left-0 w-full h-full rounded-2xl"
              src="https://www.youtube.com/embed/sSyWxNn-TIU?si=Om8_2TiN8Y0cl12n"
              title="YouTube video player"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              referrerPolicy="strict-origin-when-cross-origin"
              allowFullScreen
            ></iframe>
          </div>
          <p className='font-gotham text-xs p-2 px-6'>video: Mals Media</p>
        </div>
      </section>

      <div className=" items-center mx-auto w-1 h-40 my-12 bg-black rounded-full"></div>

      {/* Section 4: Samen bouwen */}
      <section className='items-center'>
      <div className='grid max-w-4xl grid-cols-2 gap-6 items-center mx-auto'>

        </div>
      <div className="font-gotham text-black text-medium mx-auto max-w-prose my-12">
    <h1 className="my-6">
      Samen bouwen
    </h1>
    <p className="text-base font-gotham">
    Het team van het Van Gogh Museum komt samen met de deelnemende organisaties en ambassadeurs uit de hele stad om het verhaal van Jo te verkennen en na te denken over hoe deelnemers op persoonlijk vlak contact met haar kunnen maken.
            <br></br><br></br>
    <div className='grid max-w-prose grid-cols-2 gap-6 my-4'>
      <div>
    <img
          src={"/assets/images/image2.jpg"}
          alt={`${"hello"} Hover`}
          className="w-[100%] h-auto mx-auto object-cover rounded-3xl aspect-square "
        />
        <p className='font-gotham text-xs p-2 px-6'>afbeelding: Van Gogh Museum</p>
        </div>
        <div>
        <img
          src={"/assets/images/image1.jpeg"}
          alt={`${"hello"} Hover`}
          className="w-[100%] h-auto mx-auto object-cover rounded-3xl aspect-square "
        />
        <p className='font-gotham text-xs p-2 px-6'>afbeelding: Van Gogh Museum</p>
        </div>
        </div>
        <br></br>
        Deze brainstormsessies boden (bieden) ruimte om ideeën uit te wisselen, doelen te definiëren en een beter inzicht te krijgen in de behoeften en uitdagingen van alle betrokkenen. Door te werken volgens de methode van Design Thinking legde (legt) de groep de basis voor een zinvol, praktisch en impactvol programma voor de vrouwen die aan het project deelnemen.
    </p>
  </div>
</section>

      <div className=" items-center mx-auto w-1 h-40 my-12 bg-black rounded-full"></div>

      {/* Section 5: deelnemers */}
      <section className='items-center'>
  {/*       <img
          src={"/assets/images/BMS_1269.jpg"}
          alt={`${"hello"} Hover`}
          className="max-w-4xl mx-auto object-cover rounded-3xl my-8 aspect-[8/4] "
        /> */}
        <div className='font-gotham text-black text-medium mx-auto max-w-prose my-12'>
          <h1 className="my-6">
          De deelnemers
          </h1>
          <p className="text-base font-gotham">
          Tijdens de workshops komen veel vrouwen nieuwsgierig en vaak een beetje aarzelend binnen, omdat ze niet goed weten wat ze kunnen verwachten. Maar gaandeweg de activiteiten ontstaat er steeds meer plezier in het maken en het vinden van hun eigen creatieve stem.
            <br></br><br></br>
            Wat begint als een stap in het onbekende, wordt een plek voor ontspanning, reflectie en verbinding. Vrouwen die eerder twijfelden aan hun creatieve vaardigheden, zijn nu trots op wat ze kunnen maken en delen.
            <br></br><br></br>
            <div className='grid max-w-prose grid-cols-2 gap-6 my-4'>
              <div>
    <img
          src={"/assets/images/download_4.jpeg"}
          alt={`${"hello"} Hover`}
          className="w-[100%] h-auto mx-auto object-cover rounded-3xl aspect-square "
        />
        <p className='font-gotham text-xs p-2 px-6'>afbeelding: Van Gogh Museum</p>
        </div>
        <div>
        <img
          src={"/assets/images/BMS_0977.jpg"}
          alt={`${"hello"} Hover`}
          className="w-[100%] h-auto mx-auto object-cover rounded-3xl aspect-square "
        />
        <p className='font-gotham text-xs p-2 px-6'>afbeelding: Blooming Moon Studio</p>
        </div>
        </div>
        <br></br>
            Door groepsactiviteiten, humor en momenten van kwetsbaarheid ontstaat er een sterk gevoel van gemeenschap. Voor velen wordt het verhaal van Jo een spiegel, een herinnering aan hun eigen veerkracht, terwijl voor anderen de collectieve ervaring van creativiteit en saamhorigheid het meest tot hen spreekt.
          </p>
        </div>
      </section>

      <div className=" items-center mx-auto w-1 h-40 my-12 bg-black rounded-full"></div>

      {/* Section 6: Ontdekken van creativiteit */}
      <section className="items-center">
      <div className='grid max-w-4xl grid-cols-2 gap-6 items-center mx-auto'>
      <div>
      <img
          src={"/assets/images/download_23.jpg"}
          alt={`${"hello"} Hover`}
          className="w-[100%] h-auto mx-auto object-cover rounded-3xl aspect-square "
        />
        <p className='font-gotham text-xs p-2 px-6'>afbeelding: Van Gogh Museum</p>
        </div>
        <div>
        <img
          src={"/assets/images/MG_7419.jpg"}
          alt={`${"hello"} Hover`}
          className="w-[100%] h-auto mx-auto object-cover rounded-3xl aspect-square "
        />
        <p className='font-gotham text-xs p-2 px-6'>afbeelding: Van Gogh Museum</p>
        </div>
        </div>

  {/* TEXT — narrow & centered */}
  <div className="font-gotham text-black text-medium mx-auto max-w-prose my-12">
    <h1 className="my-6">
    Ontdekken van creativiteit
    </h1>
    <p className="text-base font-gotham">
    Tijdens de workshops brengen vrouwen het verhaal van zowel Jo als henzelf tot leven door middel van schilderen, tekenen, schrijven, mozaïeken, borduren, keramiek en kalligrafie.
            <br></br><br></br>
            Ze maken persoonlijke zelfportretten en gezamenlijke kunstwerken, waarbij ze experimenteren met kleuren, materialen en motieven.
            <br></br><br></br>
            Elke activiteit nodigt uit tot reflectie, speelse verkenning en verbinding, waardoor deelnemers nieuwe creatieve vaardigheden ontdekken, zelfvertrouwen krijgen en betekenisvolle momenten met elkaar delen.
          </p>
  </div>
</section>

      <div className=" items-center mx-auto w-1 h-40 my-12 bg-black rounded-full"></div>

      {/* Section 7: Vrouwenstemmen vieren */}
      <section className="items-center">
      <div className='mx-auto max-w-4xl'>
      <img
          src={"/assets/images/BMS_1045.jpg"}
          alt={`${"hello"} Hover`}
          className="w-full h-auto object-cover rounded-3xl aspect-[8/4]"
        />
        <p className='font-gotham text-xs p-2 px-6'>afbeelding: Blooming Moon Studio</p>
        </div>

  {/* TEXT — narrow & centered */}
  <div className="font-gotham text-black text-medium mx-auto max-w-prose my-12">
  <h1 className="my-6">
            Vrouwenstemmen vieren
          </h1>
          <p className="text-base font-gotham">
            Ik ben Jo! wordt gevierd met een reeks publieke evenementen die het verhaal van Jo van Gogh-Bonger en de stemmen van de deelnemers onder de aandacht brengen van een breder publiek.
          </p>
  </div>
</section>

      

      <div className=" items-center mx-auto w-1 h-40 my-12 bg-black rounded-full"></div>

      {/* Event: Pakhuis de Zwijger */}
      <section className='items-center'>
        <div className='font-gotham text-black text-medium mx-auto max-w-prose my-12'>
        <tag className="font-gotham text-background bg-black rounded-full px-4 py-2 text-bold">Evenement</tag>
          <h1 className="my-6">
            Ik ben Jo: Pakhuis de Zwijger
          </h1>
        </div>

        <div className="mb-2 mx-auto max-w-4xl rounded-2xl overflow-hidden">
          <div className="relative w-full h-0 pb-[56.25%]">
            <iframe
              className="absolute top-0 left-0 w-full h-full rounded-2xl"
              src="https://www.youtube.com/embed/AZ1MSXo-7X8?si=XZjksksDYbsuCwfH"
              title="YouTube video player"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              referrerPolicy="strict-origin-when-cross-origin"
              allowFullScreen
            ></iframe>
            
          </div>
          <p className='font-gotham text-xs p-2 px-6'>video: Pakhuis de Zwijger</p>
        </div>
      </section>

      <div className=" items-center mx-auto w-1 h-40 my-12 bg-black rounded-full"></div>

      {/* Event: Vrouwendag */}
<section className="mx-auto my-12 max-w-5xl">
  <div className="flex flex-col gap-8 items-center md:flex-row md:items-center">
    {/* LEFT column */}
    <div className="w-full md:w-1/2">
      <img
        src="/assets/images/BMS_1161.jpg"
        alt="hello Hover"
        className="w-full h-auto object-cover rounded-3xl aspect-square"
      />
      <p className="font-gotham text-xs p-2 px-6">afbeelding: Blooming Moon Studio</p>
    </div>

    {/* RIGHT column */}
    <div className="w-full md:w-1/2 font-gotham text-black text-medium mx-auto max-w-prose my-6">
      <span className="font-gotham text-background bg-black rounded-full px-4 py-2 font-bold">
        Evenement
      </span>
      <h1 className="my-6">Ik ben Jo: Internationale vrouwendag</h1>
    </div>
  </div>
</section>

      <div className=" items-center mx-auto w-1 h-40 my-12 bg-black rounded-full"></div>

      {/* Tentoonstelling: Van gogh */}
      <section className="items-center">

          {/* TEXT — narrow & centered */}
  <div className="font-gotham text-black text-medium mx-auto max-w-prose my-6">
  <tag className="font-gotham text-background bg-black rounded-full px-4 py-2 text-bold">Tentoonstelling</tag>
  <h1 className="my-6">
  Ik ben Jo: Van Gogh Museum
          </h1>
  </div>

  {/* IMAGE */}
      <div className='mx-auto max-w-4xl'>
      <img
         src={"/assets/images/BMS_0846.jpg"}
          alt={`${"hello"} Hover`}
          className="w-full h-auto object-cover rounded-3xl aspect-[8/4]"
        />
        <p className='font-gotham text-xs p-2 px-6'>afbeelding: Blooming Moon Studio</p>
        </div>


</section>

      <div className=" items-center mx-auto w-1 h-40 my-12 bg-black rounded-full"></div>

            {/* Event: Conservatorium*/}
<section className="mx-auto my-12 max-w-5xl">
  <div className="flex flex-col gap-8 items-center md:flex-row md:items-center">


              {/* LEFT column */}
    <div className="w-full md:w-1/2">
      <img
            src={"/assets/images/Ik-ben-Jo_opening-Conservatorium-Hotel13.jpeg"}
        alt="hello Hover"
        className="w-full h-auto object-cover rounded-3xl aspect-square"
      />
      <p className="font-gotham text-xs p-2 px-6">afbeelding: Blooming Moon Studio</p>
    </div>

        <div className="w-full md:w-1/2 font-gotham text-black text-medium mx-auto max-w-prose my-6">
      <span className="font-gotham text-background bg-black rounded-full px-4 py-2 font-bold">
        Evenement
      </span>
      <h1 className="my-6">Ik ben Jo: Conservatorium Hotel</h1>
    </div>
    </div>
      </section>

      <div className=" items-center mx-auto w-1 h-40 my-12 bg-black rounded-full"></div>

      {/* Tentoonstelling: OBA */}
      <section className="items-center">

{/* TEXT — narrow & centered */}
<div className="font-gotham text-black text-medium mx-auto max-w-prose my-6">
<tag className="font-gotham text-background bg-black rounded-full px-4 py-2 text-bold">Tentoonstelling</tag>
<h1 className="my-6">
Ik ben Jo: Openbare Bibliotheek Amsterdam
</h1>
</div>

{/* IMAGE */}
<div className='mx-auto max-w-4xl'>
<img
          src={"/assets/images/BMS_1836NWest.jpg"}
alt={`${"hello"} Hover`}
className="w-full h-auto object-cover rounded-3xl aspect-[8/4]"
/>
<p className='font-gotham text-xs p-2 px-6'>afbeelding: Van Gogh Museum</p>
</div>
</section>

      <div className=" items-center mx-auto w-1 h-40 my-12 bg-black rounded-full"></div>

            {/* Event: Premiere docu */}

<section className="mx-auto my-12 max-w-5xl">
  <div className="flex flex-col gap-8 items-center md:flex-row md:items-center">


              {/* LEFT column */}
    <div className="w-full md:w-1/2">
      <img
            src={"/assets/images/BMS_2431.jpg"}
        alt="hello Hover"
        className="w-full h-auto object-cover rounded-3xl aspect-square"
      />
      <p className="font-gotham text-xs p-2 px-6">afbeelding: Blooming Moon Studio</p>
    </div>

        <div className="w-full md:w-1/2 font-gotham text-black text-medium mx-auto max-w-prose my-6">
      <span className="font-gotham text-background bg-black rounded-full px-4 py-2 font-bold">
        Evenement
      </span>
      <h1 className="my-6">Premiere: Ik ben Jo (documentaire)</h1>
    </div>
    </div>
      </section>

      <div className=" items-center mx-auto w-1 h-40 my-12 bg-black rounded-full"></div>

      {/* Event: Bijlmerpark theater */}
      <section className="items-center">

{/* TEXT — narrow & centered */}
<div className="font-gotham text-black text-medium mx-auto max-w-prose my-6">
<tag className="font-gotham text-background bg-black rounded-full px-4 py-2 text-bold">Evenement</tag>
<h1 className="my-6">
Ik ben Jo: Bijlmer Parktheater
</h1>
</div>

{/* IMAGE */}
<div className='mx-auto max-w-4xl'>
<img
          src={"/assets/images/bijlmerpark theater event.jpeg"}
alt={`${"hello"} Hover`}
className="w-full h-auto object-cover rounded-3xl aspect-[8/4]"
/>
<p className='font-gotham text-xs p-2 px-6'>afbeelding: Blooming Moon Studio</p>
</div>
</section>

      <div className=" items-center mx-auto w-1 h-40 my-12 bg-black rounded-full"></div>

      {/* Section 8: Nalatenschap */}
      <section className='items-center'>
<div className='mx-auto max-w-4xl'>
      <img
          src={"/assets/images/BMS_0955.jpg"}
          alt={`${"hello"} Hover`}
          className="w-full h-auto object-cover rounded-3xl aspect-[8/4]"
        />
        <p className='font-gotham text-xs p-2 px-6'>afbeelding: Blooming Moon Studio</p>
        </div>
        <div className='font-gotham text-black text-medium mx-auto max-w-prose my-12'>
          <h1 className="my-6">
            Nalatenschap
          </h1>
          <p className="text-base font-gotham">
          Het project laat een blijvende indruk achter op zowel deelnemers als museumbezoekers. Vrouwen ontdekken nieuwe vaardigheden, krijgen meer zelfvertrouwen en bouwen betekenisvolle relaties op door middel van gedeelde ervaringen. Bezoekers van de tentoonstelling in juni 2025, waar de resultaten van het project worden getoond, dragen bij aan berichten en tekeningen voor de vrouwen, waardoor een extra laag van verbinding en erkenning ontstaat.
<br></br><br></br>
<div className="grid max-w-prose grid-cols-2 gap-6 my-4">
  <div>
  <img
    src="/assets/images/sketch4.png"
    alt=""
    className="w-full mx-auto object-contain rounded-3xl"
  />
<p className='font-gotham text-xs p-2 px-6'>afbeelding: Van Gogh Museum</p>
</div>
<div>
  <img
    src="/assets/images/sketch3.png"
    alt=""
    className="w-full mx-auto object-contain rounded-3xl"
  />
  <p className='font-gotham text-xs p-2 px-6'>afbeelding: Van Gogh Museum</p>
  </div>
</div>

        <br></br>
Naast de activiteiten bevordert het project een gevoel van empowerment, nieuwsgierigheid en gemeenschapszin dat deelnemers, partners en publiek blijft inspireren. Hiermee wordt de basis gelegd voor toekomstige initiatieven en betrokkenheid bij het museum en gemeenschappen in heel Amsterdam.</p>
        </div>
      </section>

    </div>
  );
}

export default Verhaal;
